import { SessionCountdown } from "@/features/extend-session/components/session-countdown";
import { RaisedHandsCounter } from "@/features/raise-hand/components/raised-hands-counter";

import { CallTitle } from "./call-title";
import { IsRecordingLabel } from "./is-recording-label";

export function CallHeader() {
  return (
    <div className="my-2 flex h-7 items-center bg-background px-4">
      <SessionCountdown className="mr-4 border-r border-muted" />
      <CallTitle className="mr-4" />
      <div className="flex items-center gap-2">
        <RaisedHandsCounter />
        <IsRecordingLabel />
      </div>
    </div>
  );
}
